// extracted by mini-css-extract-plugin
export var container = "_5v-0";
export var error = "_5v-9";
export var label = "_5v-5";
export var light = "_5v-6";
export var md = "_5v-3";
export var sm = "_5v-2";
export var thin = "_5v-8";
export var thinBold = "_5v-7";
export var vertical = "_5v-4";
export var xs = "_5v-1";